import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { claimModeratorTokenFromUrl } from './lib/router';
import './styles.css';

// A shared moderation link carries its token in the hash; take it before the
// first render so the second device comes straight up as a moderation seat.
claimModeratorTokenFromUrl();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
